<div class="contact-over-image-form">
    <div style="text-align: center;">
        <h4>Register <span class="common-header-color">Now</span></h4>
        <p>Stay Ahead in Tech <span class="common-header-color">Upskill</span> with Our Expert-Led Courses!</p>
    </div>

    <form [formGroup]="contactForm" class="contact-form">
        <div class="row">
            <!-- Name Field -->
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Name" formControlName="name">
                    <div class="error-message"
                        *ngIf="contactForm.controls.name.touched && contactForm.controls.name.invalid">
                        <small *ngIf="contactForm.controls.name.errors?.required" class="text-danger">Name is
                            required.</small>
                        <small *ngIf="contactForm.controls.name.errors?.minlength" class="text-danger">
                            Name must be at least 3 characters long.
                        </small>
                    </div>
                </div>
            </div>

            <!-- Email Field -->
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Email" formControlName="email">
                    <div class="error-message"
                        *ngIf="contactForm.controls.email.touched && contactForm.controls.email.invalid">
                        <small *ngIf="contactForm.controls.email.errors?.required" class="text-danger">Email is
                            required.</small>
                        <small *ngIf="contactForm.controls.email.errors?.pattern" class="text-danger">
                            Enter a valid email address.
                        </small>
                    </div>
                </div>
            </div>

            <!-- Phone Number Field -->
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Phone" formControlName="number">
                    <div class="error-message"
                        *ngIf="contactForm.controls.number.touched && contactForm.controls.number.invalid">
                        <small *ngIf="contactForm.controls.number.errors?.required" class="text-danger">Phone number is
                            required.</small>
                        <small *ngIf="contactForm.controls.number.errors?.pattern" class="text-danger">
                            Enter a valid 10-digit phone number.
                        </small>
                    </div>
                </div>
            </div>

            <!-- College Registration Number Field -->
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="College Registration Number"
                        formControlName="collegeRegistrationNumber">
                    <div class="error-message"
                        *ngIf="contactForm.controls.collegeRegistrationNumber.touched && contactForm.controls.collegeRegistrationNumber.invalid">
                        <small class="text-danger">College registration number is required.</small>
                    </div>
                </div>
            </div>

            <!-- Submit Button & Timer Message -->
            <div class="col-lg-12 col-md-12">
                <div class="try-again-message" *ngIf="timer !== 0">
                    Please wait for <span>{{ timer }}</span> seconds before making another request!
                </div>
                <div class="enquery-form-button">
                    <button class="btn btn-sm " [disabled]="isButtonDisable" (click)="requestCallBack()">
                        Request Callback
                    </button>
                </div>
            </div>
        </div>
    </form>

</div>